import { Component } from '@angular/core';
import { SharedModule } from '../../shared/shared.module';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';

@Component({
  selector: 'app-footer',
  standalone: true,
  imports: [SharedModule, FlexLayoutModule],
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
})
export class FooterComponent {}
